import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const RootLayout = ({ children }) => {
    return (
        <div className="font-sans text-gray-800 antialiased bg-primary-light selection:bg-accent selection:text-white overflow-x-hidden min-h-screen flex flex-col">
            <Header />
            <div className="flex-1 flex flex-col">
                {children}
            </div>
            <Footer />
        </div>
    );
};

export default RootLayout;
